import apiClient, { getApiErrorInfo } from './api';

export interface VertexAgentSessionRequest {
  userId: string;
  displayName?: string;
  timeZone?: string;
}

export interface VertexAgentGetSessionRequest {
  sessionId: string;
}

export interface VertexAgentStreamQueryRequest {
  sessionId: string;
  message: string;
  courseContext?: VertexAgentCourseContext;
}

export interface VertexAgentCourseContext {
  courseId: number;
  title: string;
  category?: string;
  courseType?: string;
  creditHours?: number;
  level?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  selectedInstanceId?: number | null;
  selectedInstanceStartDate?: string;
  selectedInstanceEndDate?: string;
}

export const geminiService = {
  /**
   * Create a new Vertex AI agent session
   */
  async createSession(request: VertexAgentSessionRequest): Promise<any> {
    try {
      const response = await apiClient.post('/api/ai/sessions', request);
      return response.data;
    } catch (error) {
      throw getApiErrorInfo(error);
    }
  },

  /**
   * List all sessions for a user
   */
  async listSessions(): Promise<any> {
    try {
      const response = await apiClient.get('/api/ai/sessions');
      return response.data;
    } catch (error) {
      throw getApiErrorInfo(error);
    }
  },

  /**
   * Get a specific session
   */
  async getSession(request: VertexAgentGetSessionRequest): Promise<any> {
    try {
      const response = await apiClient.get(`/api/ai/sessions/${request.sessionId}`);
      return response.data;
    } catch (error) {
      throw getApiErrorInfo(error);
    }
  },

  /**
   * Stream a query to the Vertex AI agent
   */
  async streamQuery(request: VertexAgentStreamQueryRequest): Promise<any> {
    try {
      const response = await apiClient.post(`/api/ai/sessions/${request.sessionId}/query`, request);
      return response.data;
    } catch (error) {
      throw getApiErrorInfo(error);
    }
  },
};

export default geminiService;
